import * as React from "react";

import {AnimatePresence, motion} from "framer-motion";

import type {Notification as NotificationType} from "@client/features/notifications";

import {zIndexClasses} from "@client/style";
import {classes} from "@client/utils";

import {Notification} from "@client/shared/components/Notification";

const styles = {
    notifications: "space-y-5 px-2.5 flex flex-col max-w-[900px] mx-auto",
    app: `absolute ${zIndexClasses.notifications} left-0 right-0 bottom-2.5`,
    site: "notifications-site shrink-0 basis-auto mt-2.5",
} as const;

interface Props {
    position: "app" | "site";
    notifications: NotificationType[];
    dismissHandler?: (notification: NotificationType) => void;
}

export const Notifications = (props: Props) => {
    const notificationClasses = classes({
        [styles.notifications]: true,
        [styles.app]: props.position === "app",
        [styles.site]: props.position === "site",
    });
    const {dismissHandler} = props;

    return (
        <div className={notificationClasses}>
            <AnimatePresence initial={false}>
                {props.notifications.map((notification) => (
                    <motion.div
                        key={notification.id}
                        initial={{opacity: 0, scale: 0.3}}
                        animate={{opacity: 1, scale: 1}}
                        exit={{opacity: 0, scale: 0.2, transition: {duration: 0.3}}}
                    >
                        <Notification
                            onDismiss={
                                dismissHandler != null
                                    ? () => dismissHandler(notification)
                                    : undefined
                            }
                            notification={notification}
                        />
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};
